<template>
	<nav  aria-label="Page navigation">
		<ul v-if="showPagination" class="pagination justify-content-end">
			<li class="page-item" v-if="pagination.first"><a class="page-link" href="#" @click="changePage(pagination.first)">&laquo;</a></li>
			<li class="page-item" v-if="pagination.previous"><a class="page-link" href="#" @click="changePage(pagination.previous)">&lsaquo;</a></li>
			<li v-if="pagination.range[0] > pagination.first" class="page-item disabled d-none d-sm-flex" role="separator">
				<span class="page-link">...</span>
			</li>
			<li class="page-item" v-for="(item, index) in pagination.range" :class="isCurrentPage(item)" >
				<a class="page-link" href="#" @click="changePage(item)" >{{item}}</a>
			</li>
			<li v-if="pagination.range[pagination.range.length -1] < pagination.last" class="page-item disabled d-none d-sm-flex" role="separator">
				<span class="page-link">...</span>
			</li>

			<li class="page-item" v-if="pagination.next"><a class="page-link" href="#" @click="changePage(pagination.next)">&rsaquo;</a></li>
			<li class="page-item" v-if="pagination.last"><a class="page-link" href="#" @click="changePage(pagination.last)">&raquo;</a></li>
		</ul>
	</nav>
</template>

<script>
	export default {
		props: {
			pagination: {
				type: [Object, Array],
				default: {}
			},
		  	currentPage: {
			  type: Number,
			  default: 1
			},
            changePage: {
				type: Function,
				default: function(){}
			}
		},
	  	computed:{
          showPagination(){
            return this.pagination.first != undefined;
          },
		},
		methods:{
		  isCurrentPage: function(page){
		     if(page == this.currentPage){
               return 'active';
             }
             return;
		  }
		}
	}
</script>



// WEBPACK FOOTER //
// Pagination.vue?70572499